import { api } from "@/api/axios.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import { ApiTeam, ApiTeamFilter, ApiTeamSavePayload } from "@/types/team.types.ts";
import { ApiPhotoUpdate } from "@/types/comment.types.ts";

export const apiTeams = {
  search: async function (filter: ApiTeamFilter, signal: AbortSignal) {
    return api.post<ApiPagedData<ApiTeam>>("/api/v1/teams/search", filter, signal);
  },
  getById: async function (id: number) {
    return api.get<ApiTeam>(`/api/v1/teams/${id}`);
  },
  create: async function (payload: ApiTeamSavePayload) {
    return api.post<ApiTeam>("/api/v1/teams", payload);
  },
  update: async function (id: number, payload: ApiTeamSavePayload) {
    return api.put<ApiTeam>(`/api/v1/teams/${id}`, payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/teams/${id}`);
  },
  setBackground: async function (id: number, fileUUID: string) {
    return api.put<ApiPhotoUpdate>(`/api/v1/teams/${id}/background`, {
      file_uuid: fileUUID,
    });
  },
  deleteBackground: async function (id: number) {
    return api.delete<ApiPhotoUpdate>(`/api/v1/teams/${id}/background`);
  },
};
